import React from "react";
import "./ProgressBarsWithArrows.css";

interface ProgressBarWithArrowsProps {
  onBack?: () => void;
  onNext?: () => void;
}

const ProgressBarWithArrows: React.FC<ProgressBarWithArrowsProps> = ({
  onBack,
  onNext,
}) => {
  return (
    <div className="bars-container">
      <button
        className="arrow-btn"
        onClick={onBack || (() => console.log("Go back"))}
      >
        ←
      </button>
      <div className="bars">
        <div className="progress-bar purple"></div>
        <div className="progress-bar dark-blue"></div>
        <div className="progress-bar grey"></div>
      </div>
      <button
        className="arrow-btn"
        onClick={onNext || (() => console.log("Go next"))}
      >
        →
      </button>
    </div>
  );
};

export default ProgressBarWithArrows;
